import { render, staticRenderFns } from "./RegistrationTrialLes.vue?vue&type=template&id=445e4aaa&"
import script from "./RegistrationTrialLes.vue?vue&type=script&lang=js&"
export * from "./RegistrationTrialLes.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationTrialLes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports